// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"KI-z","smallCardRow":"LI-z","largeCardRow":"MI-z","productSearchRow":"NI-z","curatedRow":"OI-z"};